import React, { useContext, useState } from "react";
import { Button, DialogActions, Grid, makeStyles, FormControl, TextField as MaterialTextField } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { laboratoryServices } from "../services";
import { AuthContext } from "../context";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField, ModalBase } from "./";

export default function AddLaboratory(props) {
	const classes = useStyles();
	const { specialtiesList } = props;
	const { register, handleSubmit, errors, watch } = useForm();
	const { authState } = useContext(AuthContext);
	const [specialties, setSpecialties] = useState([]);

	const saveLaboratory = async (dataToInsert) => {
		const laboratory =
			authState.user.role.name === "LABORATORY_ADMIN"
				? {
						username: dataToInsert.username,
						email: dataToInsert.email,
						roleId: "611a6abd8e0b7eb755d1b213",
						password: dataToInsert.password,
						laboratoryId: authState.user.laboratory._id,
						specialties,
				  }
				: authState.user.role.name === "USER_LABORATORY"
				? {
						username: dataToInsert.username,
						email: dataToInsert.email,
						roleId: "611ac5468e0b7eb755d1b214",
						password: dataToInsert.password,
						laboratoryId: authState.user.laboratory._id,
						specialties,
				  }
				: {
						username: dataToInsert.username,
						email: dataToInsert.email,
						roleId: "5fdb9e3db3bfce86908e4410",
						password: dataToInsert.password,
						laboratory: {
							name: dataToInsert.name,
							specialties,
						},
				  };
		const { status, response } = await laboratoryServices.addLaboratory({ laboratory, token: authState.token });
		switch (status) {
			case 201:
				await props.close();
				props.reload();
				props.toast(response.message, true);
				break;
			case 200:
				await props.close();
				props.toast(response.error.message, true);
				break;
			case 400:
				await props.close();
				props.toast(response.error.message, true);
				break;
			default:
				break;
		}
	};

	return (
		<ModalBase
			open={props.open}
			close={props.close}
			title={`Agregar ${
				authState.user.role.name === "LABORATORY_ADMIN" || authState.user.role.name === "USER_LABORATORY" ? "usuario" : "laboratorio"
			}`}
		>
			<form className={classes.form} onSubmit={handleSubmit(saveLaboratory)}>
				<Grid container spacing={2}>
					{authState.user.role.name === "ADMINISTRADOR" ||
						(authState.user.role.name === "MASTER" && (
							<Grid item xs={12} sm={12}>
								<TextField
									fullWidth
									id="name"
									name="name"
									autoComplete="name"
									placeholder="Nombre *"
									size="small"
									inputRef={register({
										required: "Nombre requerido",
									})}
									error={errors.name ? true : false}
									helperText={errors.name ? errors.name.message : ""}
								/>
							</Grid>
						))}

					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="username"
							label="Usuario"
							name="username"
							autoComplete="username"
							size="small"
							placeholder="Usuario *"
							inputRef={register({
								required: "Usuario requerido",
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.username ? true : false}
							helperText={errors.username ? errors.username.message : ""}
						/>
					</Grid>

					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="email"
							label="Correo electrónico"
							name="email"
							size="small"
							autoComplete="email"
							placeholder="Email *"
							inputRef={register({
								required: "Correo requerido",
								pattern: {
									value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
									message: "Formato de correo inválido",
								},
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.email ? true : false}
							helperText={errors.email ? errors.email.message : ""}
						/>
					</Grid>
					{authState.user.role.name !== "LABORATORY_ADMIN" && specialtiesList && (
						<Grid item lg={12} xs={12} sm={12}>
							<FormControl variant="outlined" className={`${classes.formControl}  ${classes.shrinkLabel}`}>
								<Autocomplete
									multiple
									id="especialidades"
									options={specialtiesList}
									getOptionLabel={(option) => option.name}
									filterSelectedOptions
									variant="outlined"
									label="Especialidades"
									value={specialties}
									onChange={(event, newValue) => {
										setSpecialties(newValue);
									}}
									renderInput={(params) => (
										<MaterialTextField
											{...params}
											id="especialidades"
											name="especialidades"
											variant="outlined"
											label="especialidades"
											placeholder="especialidades"
											error={errors.especialidades ? true : false}
											helperText={errors.especialidades ? errors.especialidades.message : ""}
										/>
									)}
								/>
							</FormControl>
						</Grid>
					)}
					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="password"
							label="Contrasena"
							name="password"
							type="password"
							autoComplete="password"
							placeholder="Contraseña *"
							size="small"
							inputRef={register({
								required: "Contrasena requerida",
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.password ? true : false}
							helperText={errors.password ? errors.password.message : ""}
						/>
					</Grid>

					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="passworRepeat"
							label="Confirmar Contrasena"
							name="passworRepeat"
							type="password"
							placeholder="Confirmar contraseña *"
							autoComplete="passworRepeat"
							size="small"
							inputRef={register({
								required: "Confirmar contraseña requerida",
								validate: (value) => value === watch("password") || "Las contraseñas no coinciden.",
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.passworRepeat ? true : false}
							helperText={errors.passworRepeat ? errors.passworRepeat.message : ""}
						/>
					</Grid>
				</Grid>
				<DialogActions>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="secondary"
						className={classes.submit}
						style={{ textTransform: "capitalize", borderRadius: "20px" }}
					>
						Guardar
					</Button>
				</DialogActions>
			</form>
		</ModalBase>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(2),
		top: theme.spacing(2),
		color: "#FFF",
		backgroundColor: theme.palette.secondary.main,
		width: 30,
		height: 30,
		"&:hover": {
			backgroundColor: theme.palette.secondary.main,
		},
	},
	dialogTitle: {
		textAlign: "left",
		color: theme.palette.primary.main,
		"& h2": {
			fontWeight: "bold",
		},
	},
	formControl: {
		width: "100%",
		minWidth: 120,
		"& div": {
			borderRadius: 25,
		},
	},
	shrinkLabel: {
		"& > label:nth-child(1)": {
			transform: "translate(14px, -6px) scale(0.75)",
		},
		"& > div:nth-child(2)": {
			"& > fieldset": {
				"& > legend": {
					maxWidth: 1000,
				},
			},
		},
	},
}));
